import { CircularProgress, CircularProgressProps, styled } from '@mui/material';
import * as React from 'react';

const SpinnerContainer = styled('div')({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

export const Spinner = (props: CircularProgressProps) => {
    return (
        <SpinnerContainer>
            <CircularProgress {...props} />
        </SpinnerContainer>
    );
};
